import { Component, Input } from '@angular/core'
import { Writer, Keyword } from '../types'
import { KeywordActions } from '../actions/keyword-actions'
import { CustomerActions } from '../actions/customer-actions'
import sweetAlert from '../bmAlert'
import { Apollo } from 'apollo-angular'
import gql from 'graphql-tag'

@Component({
  selector: 'proposed-topic-box',
  template: `
    <accept-topic-modal *ngIf="showAcceptModal" [keyword]="keyword" (submit)="onAccept($event)" (cancel)="showAcceptModal = false" [writer]="writer"></accept-topic-modal>
    <div class="proposed-topic-box">
      <div class="row">
        <div class="col-2">
          <div class="float-left">
            <writer-avatar [writer]="writer" [customerId]="customerId"></writer-avatar>
          </div>
        </div>
        <div class="col-8 biggish-text cursor-pointer" (click)="expand()">
          <div class="bold">{{ keyword.phrase }}</div>
          <ng-template [ngIf]="keyword.description">
            <div *ngIf="!keyword.expanded">{{ shortDescription }}</div>
            <div *ngIf="keyword.expanded">{{ keyword.description }}</div>
          </ng-template>
        </div>
        <div class="col-2">
          <div class="float-right text-center" *ngIf="proposed">
            <button class="btn btn-xs btn-success btn-outline-success square-corners" (click)="showAcceptModal = true">Accept</button>
            <button class="btn btn-xs btn-danger square-corners tiny-top-buffer" (click)="decline()">Decline</button>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [`
  `]
})
export class ProposedTopicBox {
  @Input() writer: Writer;
  @Input() keyword: Keyword;
  @Input() customerId: number;
  showAcceptModal: boolean = false;

  constructor(
    private keywordActions: KeywordActions,
    private customerActions: CustomerActions,
    private apollo: Apollo
  ) {}

  get accepted(): boolean {
    return !this.proposed
  }

  get proposed(): boolean {
    return this.keyword.state === 'proposed'
  }

  get shortDescription(): string {
    if (this.keyword.description.toString().length > 100) {
      return this.keyword.description.substr(0, 100) + '...'
    } else {
      return this.keyword.description
    }
  }

  expand(): void {
    this.keywordActions.toggleKeywordExpanded(this.keyword, !this.keyword.expanded)
  }

  onAccept(): void {
    this.showAcceptModal = false
    if (this.keyword) this.keywordActions.acceptKeyword(this.keyword.customerId, this.keyword.id).then(() => {
      this.updateCustomer()
    })
  }

  decline(): void {
    if (this.keyword) {
      sweetAlert.confirm({text: `Are you sure you would like to decline '${this.keyword.phrase}'?`}).then(confirm => {
        if (confirm) {
          this.keywordActions.declineKeyword(this.keyword.customerId, this.keyword.id).then(() => {
            this.updateCustomer()
          })
        }
      })
    }
  }

  // To reflect changes to customer proposedKeywordsCount
  updateCustomer(): void {
    // To reflect changes in nuclear store
    this.customerActions.loadCustomer(this.customerId)

    // To reflect changes in apollo store
    this.apollo.query({
      query: gql`
        query ProposedKeywordsCountQuery($id: ID!) {
          customer(id: $id) {
            id
            proposedKeywordsCount
          }
        }
      `,
      variables: { id: this.customerId },
      fetchPolicy: 'network-only'
    }).subscribe()
  }
}
